import { Filter } from '@cubejs-client/core';

import { DimPurchaseOrderField } from '~/common/types/cubes/DimPuchaseOrder';
import { useModuleContext } from '~/components/ModuleContextProvider';

import { PurchaseOrderCountWidget } from './PurchaseOrderCountWidget';

export const SupplierPurchaseOrderCountWidget = () => {
  const { entityId } = useModuleContext();
  const filters: Filter[] = [
    {
      member: DimPurchaseOrderField.SUPPLIER_ID,
      operator: 'equals',
      values: [entityId],
    },
  ];
  return <PurchaseOrderCountWidget filters={filters} />;
};
